import Money from '../views/dashboard/components/general/Money/index'
import Snakbara from '../views/dashboard/components/general/snakbar/snakbar'
import now from '../../now.json'
// import dialogComponent from '../views/dashboard/components/general/dialog/index'
export default {
  data: () => ({
    bankRemain: 0,
    bankRemainColor: 'blue',
    errorData: null,
    errorDialog: false,
    innerComponent: false,
    errorMessage: false,
    defaultCurrency: null,
    env: null,
    today: null,
    snakbar: null,
    snakbarText: null,
    snakbarColor: null,
    options: {
      locale: 'en-US',
      prefix: '',
      suffix: ' ',
      precision: 0
    }
  }),
  components: {
    // dialogComponent,
    Money,
    Snakbara
  },
  directives: {
    disabledIconFocus: {
      bind (el) {
        el.querySelectorAll('.v-input__icon button').forEach(x => x.setAttribute('tabindex', -1))
      }
    }
  },
  watch: {
    bank () {
      this.bankRemainCheck()
    },
    currency () {
      if (this.currency && this.currency.decimal) {
        this.options = {
          locale: 'en-US',
          prefix: '',
          suffix: ' ',
          precision: this.currency.decimal
        }
      }
    }
  },
  beforeMount () {
    this.env = now
    this.options = {
      locale: 'en-US',
      prefix: '',
      suffix: ' ',
      precision: this.$store.state.currency.decimal
    }
  },
  mounted () {
    var storage = JSON.parse(localStorage.getItem('token'))
    if (storage) {
      this.defaultCurrency = this.getDefault('defaultCurrency')
      this.today = this.setDate()
      this.options.suffix = this.$store.state.currencySymbol
    }
    this.lockStatusItems = [
      {
        value: 'active',
        text: this.$t('active')
      },
      {
        value: 'deactive',
        text: this.$t('deactive')
      }
    ]
  },
  methods: {
    toDecimal (x) {
      return Number.parseFloat(x).toFixed(this.$store.state.currency.decimal)
    },
    bankRemainCheck (price = 0) {
      // if (this.bank && this.bank.remain !== undefined) {
      //   if (this.$route.params.id != null) {
      //     this.bankRemain = parseFloat((this.bank.currency_id === this.$store.state.currency.id ? this.bank.remain.remain : this.bank.remain.currency_remain)) - parseFloat(price)
      //   } else {
      //     this.bankRemain = parseFloat((this.bank.currency_id === this.$store.state.currency.id ? this.bank.remain.remain : this.bank.remain.currency_remain)) - parseFloat(price)
      //   }
      //
      //   this.bankRemainColor = 'grey'
      //   if (this.bankRemain > 0) {
      //     this.bankRemainColor = 'green'
      //   }
      //   if (this.bankRemain < 0) {
      //     this.bankRemainColor = 'pink'
      //   }
      //   if (this.bank && parseFloat(price) > parseFloat((this.bank.currency_id === this.$store.state.currency.id ? this.bank.remain.remain : this.bank.remain.currency_remain))) {
      //     this.price = 0
      //     this.bankRemain = parseFloat((this.bank.currency_id === this.$store.state.currency.id ? this.bank.remain.remain : this.bank.remain.currency_remain)) - parseFloat(price)
      //     this.snakbarText = this.$t('alert-pay-amount-bigger-than-bank-remain')
      //     this.snakbarColor = 'pink'
      //     this.snakbar = true
      //   }
      // }
    },
    setDate: function () {
      var m = this.$moment()
      if (!this.date) {
        var today = ''
        if (this.$store.state.date_locale === 'fa,en') {
          today = m.format('jYYYY/jMM/jDD')
        }
        if (this.$store.state.date_locale === 'en,fa') {
          today = m.format('YYYY/MM/DD')
        }
        if (today < this.$store.state.startDate) {
          today = this.$store.state.startDate
        }
        if (today > this.$store.state.endDate) {
          today = this.$store.state.endDate
        }
        this.date = today
        return today
      }
    },
    setDateMonth: function (e) {
      var m = this.$moment()
      var today = ''
      if (this.$store.state.date_locale === 'fa,en') {
        today = m.format('jMMMM')
      }
      if (this.$store.state.date_locale === 'en,fa') {
        today = m.format('MM')
      }
      return today
    },
    getToday: function (e) {
      var m = this.$moment()
      var today = ''
      if (this.$store.state.date_locale === 'fa,en') {
        today = m.format('jYYYY/jMM/jDD')
      }
      if (this.$store.state.date_locale === 'en,fa') {
        today = m.format('YYYY/MM/DD')
      }
      return today
    },
    serverErrorHandeler (err) {
      var app = this
      var error = err.response
      if (error && error.status === 420) {
        app.snakbarText = error.data.message
        app.snakbarColor = 'pink'
        app.snakbar = true
      }
      if (error && error.status === 502) {
        if (app.$route.name === 'logout' || app.$route.name === 'login') {
          app.snakbarText = error.data.message
          app.snakbarColor = 'pink'
          app.snakbar = true
        } else {
          app.$router.push({ name: 'logout' })
        }
      }
      if (error && error.status === 422) {
        error = err.response.data.errors
        error = Object.keys(error).map((key) => [error[key]])
        var msg = app.$t('error') + ' : '
        error.map(function (value, key) {
          var res = value[0][0].split('|')
          var text = res[0]
          msg = msg + '#' + text
        })
        this.snakbarText = msg
        this.snakbarColor = 'pink'
        this.snakbar = true
      }
      if (error && error.status === 401) {
        app.$router.push({ name: 'logout' })
      }
      if (error && error.status === 423) {
        app.errorDialog = true
        app.errorMessage = err.response.data.errors.message[0]
        app.errorData = err.response.data.errors.data
      }
      if (error && error.status >= 400) {
        app.snakbarText = error.data.message
        app.snakbarColor = 'pink'
        app.snakbar = true
      }
      if (error && error.status === 429) {
        app.snakbarText = app.$t(error.data.message)
        app.snakbarColor = 'pink'
        app.snakbar = true
      }
    },
    // go to router name
    goTo (to) {
      this.$router.push({ name: to }).catch(() => {})
    },
    storage () {
      return JSON.parse(localStorage.getItem('token'))
    },
    // get defaul value function
    getDefault (type) {
      var app = this
      if (this.$store.state.currency) {
        app.defaultCurrency = this.$store.state.currency
      } else {
        app.$axios.get(app.$endpoint + 'getdetail?select=' + type)
          .then(res => {
            res = res.data
            app.defaultCurrency = res
            app.$store.commit('SET_CURRENCY', res)
          })
          .finally(() => (app.isLoading = false))
      }
    },
    setheaderPrint (data) {
      var storage = JSON.parse(localStorage.getItem('token'))
      var elm = this.$refs.table.$el.querySelector('.v-data-table-header')
      var button = document.createElement('tr')
      var fromDate = (data.fromDate ? '<div align="right" class="header-print-th">' + this.$t('fromDate') + ': ' + data.fromDate + '</div>' : '')
      var toDate = (data.toDate ? '<div align="right" class="header-print-th">' + this.$t('toDate') + ': ' + data.toDate + '</div>' : '')
      button.innerHTML = '<th colspan="' + this.headerPrint.length + '">' +
        '<div class="header-print">' +
        '<div align="center" class="header-print-logo"><img src="/favicon.png" width="50"></div>' +
        '<div align="center" class="header-print-th"><div>' + this.$t('abrName') + ': ' + storage.init.abrName + '</div></div>' +
        '<div align="right" class="header-print-th">' + this.$t('report') + ': ' + data.title + '</div>' +
        '' + fromDate + '' +
        '' + toDate + '' +
        '<div class="header-print-th"><div>' + this.$t('user') + ': ' + data.user + '</div></div>' +
        '<div align="center" class="header-print-th"><div>' + this.$t('datePrint') + ': ' + this.today + '</div></div>' +
        '</div></th>'
      elm.prepend(button)
    },
    newTab (to, item) {
      var routeData = this.$router.resolve({ name: to, params: { id: item.id } })
      window.open(routeData.href, '_blank')
    }
  }
}
